import "./Section.scss";
import { useState } from "react";
import {
  Row
} from "antd";
import { Paragraph, FieldSet, Table, Subsection, Text, Decision } from '../'
import { saveSectionValuesPromise } from "../../promises";

import { useTranslation } from "react-i18next";

const Section = ({ client, record, decl, section, mode, refreshForm, showErrors, lang }) => {
  const { t } = useTranslation()
  const [ sSection, setSSection ] = useState(section)

  const refreshSection = (s, updateValues=true) => {
    setSSection(s)

    if(refreshForm) {
      let _d = { ...decl }
      let _sec = []
      _d.sections.map((sec, i) => {
        if(sec.id === s.id) {
          _sec.push(s)
        }else {
          _sec.push(sec)
        }
      })
      _d.sections = _sec
      refreshForm(_d)

      if(mode === 'html' && updateValues) {
        saveSectionValuesPromise(decl.id, s)
      }
     }
  }

  const handleChangeValues = (component, updateValues=true) => {
    let _s = { ...section }
    let comp = []
    _s.components.map((c, i) => {
      if(c.id === component.id) {
        comp.push(component)
      }else if(c.fieldSet && c.fieldSet.id === component.id) {
        comp.push({ ...c, fieldSet: component })
      }else {
        let _c = {...c}
        if(_c.components) {
          let _comp = []
          _c.components.map((c1, i) => {
            if(c1.id === component.id) {
              _comp.push(component)
            }else if(c1.fieldSet && c1.fieldSet.id === component.id) {
              _comp.push({ ...c1, fieldSet: component })
            }else {
              _comp.push(c1)
            }
          })
          _c.components = _comp
        }
        comp.push(_c)
      }
    })
    _s.components = comp
    refreshSection(_s, updateValues)
  }

  return (
    <div className={'form-manager-section-content mode-'+mode}>
        <h4 className="section-title">{(sSection && sSection.title && sSection.title[lang])??<i>[{t('forms.manager.section.title.default', {ns: 'forms'})}]</i>}</h4>
        <div className="section-body">
        { sSection.components && sSection.components.map((component, index) =>
            ((component.type === 'PARAGRAPH' && component.text) || component.type !== 'PARAGRAPH') &&
              <Row className={'section-component section-component-type-'+component.type}>
                  { component.type === 'PARAGRAPH' &&
                      <Paragraph component={component} record={record} mode={mode} lang={lang} handleChangeValues={mode!=="pdf" ? handleChangeValues:null} />
                  }
                  { component.type === 'FIELDSET' &&
                      <FieldSet formId={decl?.id} client={client} record={record} section={sSection} parent={sSection} component={component} mode={mode} lang={lang}
                        showErrors={showErrors}
                        handleChangeValues={mode!=="pdf" ? handleChangeValues:null} 
                      />
                  }
                  { (component.type === 'TABLE' || component.type === 'DECL') &&
                      <Table formId={decl?.id} client={client} record={record} section={sSection} component={component} mode={mode} lang={lang} handleChangeValues={mode!=="pdf" ? handleChangeValues:null} showErrors={showErrors} />
                  }
                  { component.type === 'TEXT' &&
                      <Text component={component} mode={mode} lang={lang} handleChangeValues={mode!=="pdf" ? handleChangeValues:null} />
                  }
                  { component.type === 'SUBSECTION' &&
                    <Subsection formId={decl?.id} client={client} record={record} section={section} component={component} subsection={component} mode={mode} lang={lang} showErrors={showErrors} handleChangeValues={mode!=="pdf" ? handleChangeValues:null} />
                  }
                  { component.type === 'DECISION' &&
                    <Decision formId={decl?.id} client={client} record={record} section={section} component={component} mode={mode} lang={lang} showErrors={showErrors} handleChangeValues={mode!=="pdf" ? handleChangeValues:null} />
                  }
              </Row>
        )}
        </div>
    </div>
  )
}

export default Section;
